import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { platformServiceVersionApiRef } from './api';
import { DefaultPlatformServiceVersionApi } from './api/defaultApi';

export const platformVersionFrontendPlugin = createPlugin({
  id: 'platform-version-frontend',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: platformServiceVersionApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef
      },
      factory({ discoveryApi, fetchApi }) {
        return new DefaultPlatformServiceVersionApi({ discoveryApi, fetchApi });
      }
    })
  ]
});

export const EntityPlatformVersion = platformVersionFrontendPlugin.provide(
  createRoutableExtension({
    name: 'EntityPlatformVersion',
    component: () =>
      import('./components/EntityPlatformVersionComponent').then(m => m.EntityPlatformVersionComponent),
    mountPoint: rootRouteRef,
  }),
);

export const OverviewPlatformVersionPage = platformVersionFrontendPlugin.provide(
  createRoutableExtension({
    name: 'OverviewPlatformVersionPage',
    component: () =>
      import('./components/OverviewPlatformVersionComponent').then(m => m.OverViewPlatformVersionComponent),
    mountPoint: rootRouteRef,
  }),
);